import { RouteConfig } from 'vue-router'

const IndexJumprope2026 = () => import('../activity/sports-adventure/jumprope-2026/Index.vue')
const LotteryRewardsJumprope2026 = () => import('../activity/sports-adventure/jumprope-2026/LotteryRewards.vue')

export const indexJumprope2026Route: RouteConfig = {
  path: '/activity/sports-adventure/jumprope-2026',
  name: 'activity_sports_adventure_jumprope_2026',
  component: IndexJumprope2026,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '绳奇探险队',
  },
}

export const lotteryRewardsJumprope2026Route: RouteConfig = {
  path: '/activity/sports-adventure/jumprope-2026/lottery-rewards',
  name: 'activity_sports_adventure_jumprope_2026_lottery_rewards',
  component: LotteryRewardsJumprope2026,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '我的奖品',
  },
}

export default [indexJumprope2026Route, lotteryRewardsJumprope2026Route]
